module.exports = __webpack_public_path__ + "assets/img/sy_077.762bd24c.jpg";